<template>
    <div class="page--container" style="--offset-top: 46px;--offset-bottom: 68px;">
        <van-nav-bar 
            :title="app.name" 
            :left-arrow="canBack" @click-left="backAction()" />
        <div class="page-content--wrapper scoll-y" style="top: 46px; bottom: 68px;">
            <div class="app-content--wrapper">

                <div class="app-info-content">
                    <img class="app-icon" v-lazy="app.icon" />
                    <div class="app-name-version-content">
                        <div class="app-name-content">{{app.name}}</div>
                        <div class="app-version-content">版本号：{{application.version}}</div>
                    </div>
                </div>

                <div class="app-attr-content--wrapper">
                    <div class="app-attr-content__header">应用介绍</div>
                    <div class="app-attr-content" v-html="app.description"></div>
                </div>

                <div class="app-attr-content--wrapper">
                    <div class="app-attr-content__header">更新</div>
                    <div class="app-attr-content" v-html="app.releaseNote"></div>
                </div>

                <div class="banners--wrapper" v-if="banners && banners.length">
                    <div class="banner" v-for="(banner, index) of banners" :key="index">
                        <img :src="banner" />
                    </div>
                </div>

            </div>
            
        </div>

        <div class="page-footer">
            <van-button class="download-btn" @click="downloadAction()">下载</van-button>
            <div class="switch-platform-btn" @click="platformActionsheet = true">{{platformName}}(切换平台)</div>
        </div>

        <van-actionsheet 
            v-model="platformActionsheet" 
            :actions="platformActions" 
            cancel-text="取消"
            get-container="html"
            @select="switchPlatformAction"  />
        
        <app-wechat-tip 
            :show="showWechatTip" 
            @cancel="showWechatTip = false"/>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { isAndroid, isIOS, isInWeChart } from '@/common/util.js'

export default {
    data () {
        return {
            canBack: false,
            showWechatTip: false,
            // 0: 未知 1：android 2：iOS
            platform: 0,
            platformActionsheet: false,
            platformActions: [{
                id: 1,
                name: '安卓(Android)'
            }, {
                id: 2,
                name: '苹果(iOS)'
            }]
        }
    },
    props: ['id'],
    computed: {
        app: function () {
            return this.$store.getters.appDetail(this.id)
        },
        banners: function () {
            const { applications } = this.app
            if (!applications || (this.platform !== 1 && this.platform !== 2)) {
                return []
            }
            const app = this.platform === 1 ? applications.android : applications.ios
            return app.banners
        },
        platformName: function () {
            if (1 === this.platform) {
                return '安卓'
            } else if (2 === this.platform) {
                return '苹果'
            }
            return '未知'
        },
        application: function () {
            if (this.app && this.app.applications) {
                if (1 === this.platform) {
                    return this.app.applications.android || {}
                } else if (2 === this.platform) {
                    return this.app.applications.ios || {}
                }
            }
            return {}
        }
    },
    created () {
        if (isAndroid()) {
            this.platform = 1
        } else if (isIOS()) {
            this.platform = 2
        } else {
            this.platform = 0
        }
    },
    mounted () {
        if (this.$route.query && this.$route.query.from && 'home' === this.$route.query.from) {
            this.canBack = true
        }

        if (isInWeChart()) {
            this.showWechatTip = true
        }
    },
    methods: {
        backAction: function () {
            this.$router.go(-1)
        },
        downloadAction: function () {
            if (0 === this.platform) {
                Toast('无法获取操作系统平台，请手动切换至可用平台。')
                return
            }

            // 判断当前是否是微信打开的
            if (isInWeChart()) {
                this.showWechatTip = true
                return
            }

            if (!this.application.url) {
                Toast('应用下载链接无效，请联系开发者。')
                return
            }
            
            window.location.href = this.application.url;
        },
        switchPlatformAction: function (platform) {
            this.platform = platform.id
            this.platformActionsheet = false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/var.scss';

.app-content--wrapper{
    padding: 15px 15px 0;
    font-size: 15px;

    .app-info-content {
        display: -webkit-flex;
        display: flex;
        .app-icon {
            margin-right: 8px;
            width: 54px;
            height: 54px;
        }
    }
    .app-name-version-content {
        display: -webkit-flex;
        display: flex;
        -webkit-flex-direction: column;
        flex-direction: column;
        -webkit-justify-content: center;
        justify-content: center;

        .app-name-content {
            font-size: 17px;
            font-weight: bold;
        }

        .app-version-content {
            font-size: 14px;
            color: #b6b6b6;
        }
    }

    .app-attr-content--wrapper {
        font-size: 15px;
        .app-attr-content__header {
            margin-bottom: 4px;
        }
        .app-attr-content {
            color: #b6b6b6;
        }
    }

    & > div {
        margin-bottom: 10px;
    }
}

.page-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 20px;
    height: 68px;

    .download-btn {
        width: 100%;
        background-color: $primaryColor;
        color: #fff;;
    }

    .switch-platform-btn {
        margin-top: 4px;
        width: 100%;
        height: 18px;
        border: 0;
        font-size: 13px;
        color: #b6b6b6;
        background-color: transparent;
        text-align: center;
    }
}

.banners--wrapper {
    display: -webkit-flex;
    display: flex;
    width: 100%;
    overflow-x: auto;
    margin: 15px 0;

    .banner {
        padding: 0 5px;
    }

    .banner > img {
        width: 160px;
        height: 280px;
    }
}

</style>

